import React from "react";
import { STATUS_STYLE } from "@/lib/production";

export function StatusChip({ status, testid }) {
  const cls = STATUS_STYLE[status] || "bg-slate-100 text-slate-700";
  const pulsing = status === "IN_PROGRESS";
  const label = (status || "").replace(/_/g, " ");
  return (
    <span data-testid={testid} className={`inline-flex items-center gap-1.5 rounded-full px-2.5 py-0.5 text-xs font-medium ${cls}`}>
      <span className={`h-1.5 w-1.5 rounded-full bg-current ${pulsing ? "animate-pulse" : ""}`} />
      {label}
    </span>
  );
}
